import { CardType } from '@/common/types/Payment/CardType';

export function getExpectedCvcLength(cardType: CardType | null): number {
    return cardType === CardType.amex ? 4 : 3;
}

export function validateCvvForCardBrand(
    cvv: string,
    cardType: CardType | null
): string | null {
    const digitsOnly = cvv.replace(/\D/g, '');
    const expectedLength = getExpectedCvcLength(cardType);

    if (digitsOnly.length !== expectedLength) {
        return cardType === CardType.amex
            ? 'CVV must be 4 digits for American Express cards.'
            : 'CVV must be 3 digits.';
    }

    return null;
}
